// finds the offset
// If page is zero or the first page, offiset is 0 as we need to start from the first page

import { equals, multiply } from 'ramda';

// If page is 2, then we are moving the cursor to the next page so the next 25 rows starting from the 25th.
export const offsetFor = (page: number, page_size: number) =>
  equals(page, 0) ? 0 : multiply(page - 1, page_size);
